import { ApplicationConfig, mergeApplicationConfig } from "@angular/core";
import { provideLottieOptions } from "ngx-lottie";
import { appConfig } from "./app.config";
import player from "lottie-web";
import { provideNgxStripe } from "ngx-stripe";
import { env } from "../../env";
import {
    MAT_SELECTSEARCH_DEFAULT_OPTIONS,
    MatSelectSearchOptions,
} from "ngx-mat-select-search";

export const clientConfig: ApplicationConfig = {
    providers: [
        provideLottieOptions({ player: () => player }),
        provideNgxStripe(env.stripe_key),
        {
            provide: MAT_SELECTSEARCH_DEFAULT_OPTIONS,
            useValue: <MatSelectSearchOptions>{
                closeIcon: "delete",
                noEntriesFoundLabel: "No options found",
            },
        },
    ],
};

export const appConfigClient = mergeApplicationConfig(appConfig, clientConfig);
